import { UseMutateAsyncFunction } from 'react-query';

import {
  AdminUpdateClientInput,
  ClientDepartmentStatus,
  ClientLocationStatus,
  ContentEmailSpecInput,
  ContentEmailSpecMutation,
  CreateClientDepartmentInput,
  CreateClientDepartmentMutation,
  CreateClientDisclosureInput,
  CreateClientLocationInput,
  CreateClientLocationMutation,
  ExternalSharesSortFields,
  GroupContentApprovalType,
  SearchContentInput,
  SortDirections,
  UpdateClientDepartmentInput,
  UpdateClientDepartmentMutation,
  UpdateClientLocationInput,
  UpdateClientLocationMutation,
  UpdateUserSegmentInput,
  UserSegment,
} from 'api';

type DepartmentsLocationCreateAsyncFunction = UseMutateAsyncFunction<
  CreateClientDepartmentMutation | CreateClientLocationMutation,
  unknown,
  { data: CreateClientDepartmentInput | CreateClientLocationInput }
>;
type DepartmentsLocationUpdateAsyncFunction = UseMutateAsyncFunction<
  UpdateClientDepartmentMutation | UpdateClientLocationMutation,
  unknown,
  { data: UpdateClientDepartmentInput | UpdateClientLocationInput }
>;

export type EditableList = EditableListType.Departments | EditableListType.Locations;
export type IDisclosure = Partial<CreateClientDisclosureInput>;
export type ContentEmailValues = ContentEmailSpecMutation | ContentEmailSpecInput;
export type UserSegmentValues = UpdateUserSegmentInput | UserSegment;

export type ICreateDepartmentLocation = Partial<
  CreateClientDepartmentInput | CreateClientLocationInput
>;
export type IUpdateDepartmentLocation = Partial<
  UpdateClientDepartmentInput | UpdateClientLocationInput
>;

export interface IDepartmentsLocationsOptions {
  createAsyncMutation: DepartmentsLocationCreateAsyncFunction;
  updateAsyncMutation: DepartmentsLocationUpdateAsyncFunction;
  activeDepartmentStatus?: {
    department_status: ClientDepartmentStatus;
  };
  disabledDepartmentStatus?: {
    department_status: ClientDepartmentStatus;
  };
  activeLocationStatus?: {
    location_status?: ClientLocationStatus;
  };
  disabledLocationStatus?: {
    location_status?: ClientLocationStatus;
  };
}

export enum EditableListType {
  Departments = 'departments',
  Locations = 'locations',
}

export interface AdminUpdateClient extends AdminUpdateClientInput {
  slack_integration?: boolean;
  ms_teams_integration?: boolean;
}

export type SearchContentFilter = SearchContentInput & {
  moderation?: GroupContentApprovalType;
  isExternalShares?: boolean;
};

export interface ExternalShares {
  share_id: string;
  share_url: string;
  user_commentary: string;
}

export type ExternalSharesSortParams = {
  field: ExternalSharesSortFields;
  direction: SortDirections;
};
